declare var jQuery:any;
export class GlobalLoader {
    public static loader_id:string = "[data-global-loader]";
    public static toggle_loader( show=true ) {
        var loader = jQuery(GlobalLoader.loader_id);
        if( show ) {
            loader.show();
        } else {
            loader.hide();
        }
    }
}